<template>
    <div v-loading="loading">
        <div class="column-layout clearfix">
            <div v-cloak class="left-column fl">
                <div class="tab-container base">
                    <div class="tabs-nav">
                        <ul class="head">
                            <li class="head-item current">服务分类</li>
                        </ul>
                    </div>
                </div>
                <div class="fixed-tree" id="tree-menu" style="height: 445px;">
                    <swb-servc-cat-tree :noPostFilters="true" :enableSearch="true" @notity-change="notityChange($event)"></swb-servc-cat-tree>
                </div>
            </div>
            <div v-loading="loading" class="right-column fl">
                <div style="background-color: #fafafa;line-height: 49px;height: 49px;">
                    <span class="ml15">当前分类：【<span v-if="thisCatInfo.id != null" class="font-red">{{thisCatInfo.name}}</span><span v-else>无</span>】</span>
                    <button v-if="thisCatInfo.id != null && thisCatInfo.level < 3 && !readOnly" @click="saveRoleServcCat()" style="float: right;margin-top: 8px;" class='swb-btn swb-btn-small mr15'>
                        <span>保存</span>
                    </button>
                </div>
                <div class="table-layout">
                    <ul style="margin-top: 20px;" class="switch-list clearfix ml10">
                        <el-checkbox-group @change="checkParentChange(thisCatInfo);" v-if="thisCatInfo.id != null && thisCatInfo.level < 3" v-model="thisCatInfo.allSelected">
                            <el-checkbox :disabled="thisDisabled || readOnly" :label="thisCatInfo.id">所有下级</el-checkbox>
                        </el-checkbox-group>
                        <el-checkbox-group v-if="servcCatList.length > 0" v-model="roleServcCatIds">
                            <li v-for="servcCat in servcCatList" class="switch-item ellipsis-1" style="width: auto;margin-right: 30px;">
                                <el-checkbox :label="servcCat.id" :disabled="thisCatInfo.allSelected || thisDisabled || readOnly">
                                    <span>{{servcCat.name}}</span>
                                </el-checkbox>
                            </li>
                        </el-checkbox-group>
                    </ul>
                    <ul v-if="servcCatList == null || servcCatList.length <= 0" style="margin-top: 50px;" class="switch-list clearfix ml10">
                        <li class="switch-item ellipsis-1" style="width: auto;margin-right: 30px;">
                            <span>当前分类没有子项</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import merchtAllApi from '../../api/merchtAll'
    import servcCategApi from '../../api/servcCateg'
    //
    import SwbServcCatTree from '../categ/ServcCatTree';
    Vue.regist(SwbServcCatTree);
    export default {
        name: 'swb-mercht-tpl-role-servc-cat',
        desc: '商户模版岗位-服务分类',
        props: {
            roleId: {
                type: Number,
                default: null
            },
            readOnly: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                loading: false,
                thisDisabled: false,
                thisCatInfo: {
                    allSelected: false
                },
                servcCatList: [],
                roleServcCatIds: []
            }
        },
        created: function () {
            //
        },
        methods: {
            notityChange: function (eventData) {
                if(eventData.id != this.thisCatInfo.id) {
                    let roleId = this.roleId;
                    this.thisCatInfo = eventData;
                    this.thisDisabled = false;
                    this.roleServcCatIds = [];
                    this.getServcCatListByParentId(eventData.id);
                    this.getComRoleServcCatCatIdsByRoleId(roleId, eventData.id);
                    this.getAllSelectedComRoleServcCatCatIdsByRoleId(roleId);
                    this.getComRoleServcCatByRoleIdAndCatId(roleId, eventData.id);
                }
            },
            getServcCatListByParentId: function (parentId) {
                let self = this;
                let postData = {};
                postData.parentId = parentId;
                this.loading = true;
                servcCategApi.getServcCatListByParentId(postData, function (result) {
                    self.loading = false;
                    if(result.type === 'info') {
                        let servcCatList = result.data;
                        self.servcCatList = servcCatList;
                    } else {
                        self.$message.error(result.message);
                    }

                });
            },
            getComRoleServcCatByRoleIdAndCatId: function (roleId, catId) {
                let self = this;
                let postData = {};
                postData.tplRoleId = roleId;
                postData.catId = catId;
                merchtAllApi.getMerchtTplRoleServcCat(postData, function (result) {
                    if(result.type === 'info') {
                        let roleServcCat = result.data;
                        if(roleServcCat != null) {
                            //
                            let thisCatInfo = self.thisCatInfo;
                            thisCatInfo.allSelected = roleServcCat.allSelected;
                            thisCatInfo.excludeMode = roleServcCat.excludeMode;
                            self.thisCatInfo = Utils.merge({}, thisCatInfo);
                        }
                    } else {
                        self.$message.error(result.message);
                    }

                });
            },
            getComRoleServcCatCatIdsByRoleId: function (roleId, catId) {
                let self = this;
                let postData = {};
                postData.tplRoleId = roleId;
                postData.catParentId = catId;
                merchtAllApi.getMerchtTplRoleServcCatIds(postData, function (result) {
                    if(result.type === 'info') {
                        let catIds = result.data;
                        if(catIds != null && catIds.length > 0) {
                            self.roleServcCatIds = catIds;
                        }
                    } else {
                        self.$message.error(result.message);
                    }

                });
            },
            getAllSelectedComRoleServcCatCatIdsByRoleId: function (roleId) {
                let self = this;
                let thisCatInfo = self.thisCatInfo;
                let postData = {};
                postData.tplRoleId = roleId;
                postData.allSelected = true;
                merchtAllApi.getMerchtTplRoleServcCatIds(postData, function (result) {
                    if(result.type === 'info') {
                        let catIds = result.data;
                        if(catIds != null && catIds.length > 0) {
                            //
                            if(thisCatInfo.level < 3) {
                                if(thisCatInfo.id != thisCatInfo.catId2) {
                                    if(catIds.indexOf(thisCatInfo.catId2) >= 0) {
                                        self.thisDisabled = true;
                                        return;
                                    }
                                }
                                if(thisCatInfo.id != thisCatInfo.catId1) {
                                    if(catIds.indexOf(thisCatInfo.catId1) >= 0) {
                                        self.thisDisabled = true;
                                        return;
                                    }
                                }
                            }
                        }
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            checkParentChange: function (item) {
                this.roleServcCatIds = [];
            },
            saveRoleServcCat: function () {
                let self = this;
                //
                let thisCatInfo = this.thisCatInfo;
                let roleId = this.roleId;
                //
                let postData = {};
                postData.tplRoleId = roleId;
                postData.catId = thisCatInfo.id;
                postData.allSelected = thisCatInfo.allSelected || false;
                postData.catIds = this.roleServcCatIds || [];
                self.loading = true;
                merchtAllApi.saveMerchtTplRoleServcCats(postData, function (result, jqXhr) {
                    self.loading = false;
                    if(result.type == "info") {
                        self.$message.success("操作成功");
                        // 重新渲染列表
                        // self.getRetailerComRoleRescByRoleIdAndRescId();
                    } else {
                        self.$message.error(result.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/authx/MerchtTplRoleServcCat.vue